const listCollapser = () => {
  document.querySelectorAll('.list-collapse-toggle').forEach(toggle => {
    const link = toggle.closest('.list-collapse-btn');
    if (!link) return;

    const container = toggle.closest('.list-row-container');
    const folderIcon = container ? container.querySelector('.fa-folder') : null;
    const targetId = link.getAttribute('href').replace('#', '');
    const target = document.getElementById(targetId);
    if (!target) return;

    target.addEventListener('shown.bs.collapse', () => {
      toggle.classList.remove('fa-caret-right');
      toggle.classList.add('fa-caret-down');
      if (folderIcon) {
        folderIcon.classList.remove('fa-folder');
        folderIcon.classList.add('fa-folder-open');
      }
      link.setAttribute('aria-expanded', 'true');
    });

    target.addEventListener('hidden.bs.collapse', () => {
      toggle.classList.remove('fa-caret-down');
      toggle.classList.add('fa-caret-right');
      if (folderIcon) {
        folderIcon.classList.remove('fa-folder-open');
        folderIcon.classList.add('fa-folder');
      }
      link.setAttribute('aria-expanded', 'false');
    });
  });
};

export default listCollapser;
